import { AdvizeoFooterComponent } from '@/components/advizeo-footer/advizeo-footer.component';
import { BuildingsProvider } from '@/providers/buildings/buildings.provider';
import { DashboardingProvider } from '@/providers/dashboarding.provider';
import { RosaAuthService } from '@/rosa';
import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, type OnInit } from '@angular/core';
import { combineLatest, type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { MainHeaderComponent } from './main-header/main-header.component';

@Component({
    selector: 'app-shell-v2',
    templateUrl: './app-shell-v2.component.html',
    styleUrls: ['./app-shell-v2.component.scss'],
    imports: [LeftMenuComponent, MainHeaderComponent, AsyncPipe, AdvizeoFooterComponent]
})
export class AppShellV2Component implements OnInit {
    private _rosaAuthService = inject(RosaAuthService);
    private _dashboardingProvider = inject(DashboardingProvider);
    private _buildingsProvider = inject(BuildingsProvider);

    isAuthenticated$!: Observable<boolean>;
    showMenu$!: Observable<boolean>;

    @Input() hide: boolean = false;
    @Input() customShell: boolean = false;

    ngOnInit() {
        this.isAuthenticated$ = this._rosaAuthService.isAuthenticated$();

        this.showMenu$ = combineLatest([
            this._dashboardingProvider.isLockedInAdminMenu$(),
            this._rosaAuthService.isAuthenticated$(),
            this._buildingsProvider.getBuildingsCount$()
        ]).pipe(
            map(([isLockedInAdminMenu, isAuthenticated, buildingCount]) => isAuthenticated && (buildingCount > 0 || isLockedInAdminMenu))
        );
    }
}
